/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpigreq13Inputs */

const en_crosspostinghelpigreq13 = /** @type {(inputs: Crosspostinghelpigreq13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Instagram must be a Business or Creator account (a private account won't work). Switch it in the Instagram app: Settings → Account → Account type.`)
};

const de_crosspostinghelpigreq13 = /** @type {(inputs: Crosspostinghelpigreq13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Instagram muss ein Business- oder Creator-Konto sein (ein privates Konto geht nicht). Umstellen in der Instagram-App: Einstellungen → Konto → Kontotyp.`)
};

/**
* | output |
* | --- |
* | "Your Instagram must be a Business or Creator account (a private account won't work). Switch it in the Instagram app: Settings → Account → Account type." |
*
* @param {Crosspostinghelpigreq13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpigreq13 = /** @type {((inputs?: Crosspostinghelpigreq13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpigreq13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpigreq13(inputs)
	return de_crosspostinghelpigreq13(inputs)
});
export { crosspostinghelpigreq13 as "crosspostingHelpIgReq1" }